import { Popover } from "antd";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-light-svg-icons";
import classNames from "classnames";

interface FieldDescriptionProps {
  label?: React.ReactNode;
  description: string;
  className?: string;
}

export default function FieldDescription(props: FieldDescriptionProps) {
  return (
    <Popover
      content={() => <div style={{ width: "300px", whiteSpace: "pre-line" }}>{props.description}</div>}
      title={props.label}
      trigger={"hover"}
    >
      <FontAwesomeIcon
        className={classNames(props.className, "hover:!text-[rgba(153,153,153,0.5)] hover:cursor-pointer")}
        color={"#999999"}
        icon={faQuestionCircle}
        size={"lg"}
      />
    </Popover>
  );
}
